/* TechCure India — phone OTP (WhatsApp code via Shopify App Proxy /apps/otp)
 * 1) Cart page + cart drawer: Checkout stays locked until the phone is verified.
 * 2) [data-tco-download] sections: download buttons unlock after verification.
 * The OTP is never visible to this script; the server returns only a signed token.
 */
(function () {
  'use strict';
  if (window.__tcoLoaded) return;
  window.__tcoLoaded = true;

  var CFG = window.TCOTP || {};
  var PROXY = CFG.proxy || '/apps/otp';
  var WA_NUM = '919690796307';
  var WA_TXT = '+91 96907 96307';
  var CHECKOUT_SEL = 'button[name="checkout"], input[name="checkout"]';
  var html = document.documentElement;

  /* ---------------- messages (English only) ---------------- */
  var T = {
    invalid_phone: 'Enter a valid 10-digit Indian mobile number (starting with 6–9).',
    cooldown: 'Please wait {s} seconds before requesting a new code.',
    phone_limit: 'Too many requests for this number. Try again in {m} min.',
    ip_limit: 'Too many requests from your network. Please try again in an hour.',
    sms_failed: 'We couldn’t send the code on WhatsApp. Please check that this number has WhatsApp and try again.',
    wrong_otp: 'That code is not right. {n} attempt(s) left.',
    too_many_attempts: 'Too many wrong attempts — this code is cancelled. Please request a new code.',
    expired: 'This code has expired. Please request a new one.',
    no_otp: 'No active code for this number. Please request a new one.',
    invalid_otp_format: 'Enter the 6-digit code from WhatsApp.',
    not_verified: 'Your verification has expired. Please verify your number again.',
    file_unavailable: 'This download isn’t available yet. Please WhatsApp us for the link.',
    generic: 'Something went wrong. Please try again.',
    sent: 'Code sent on WhatsApp to {p}. It is valid for 5 minutes.',
    cart_save: 'Verified, but we couldn’t update your cart. Please refresh the page.'
  };
  function t(code, vars) {
    var m = T[code] || T.generic;
    return m.replace(/\{(\w)\}/g, function (_, k) { return vars && vars[k] != null ? vars[k] : ''; });
  }

/* ---------------- helpers ---------------- */
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function digits(s) { return String(s || '').replace(/\D/g, ''); }
  function norm10(s) { var d = digits(s); if (d.length === 12 && d.indexOf('91') === 0) d = d.slice(2); if (d.length === 11 && d[0] === '0') d = d.slice(1); return /^[6-9]\d{9}$/.test(d) ? d : null; }
  function pretty(p) { var d = digits(p).slice(-10); return '+91 ' + d.slice(0, 5) + ' ' + d.slice(5); }
  function store(k, v) { try { if (v == null) localStorage.removeItem(k); else localStorage.setItem(k, v); } catch (e) {} }
  function read(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function tokenExp(tok) {
    try { var b = String(tok).split('.')[0].replace(/-/g, '+').replace(/_/g, '/'); return JSON.parse(atob(b)).exp || 0; } catch (e) { return 0; }
  }
  function tokenValid(tok) { return !!tok && tokenExp(tok) > Date.now() + 15000; }

  var ICON = {
    phone: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><rect x="6" y="2" width="12" height="20" rx="2"/><path d="M11 18h2"/></svg>',
    ok: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" aria-hidden="true"><circle cx="12" cy="12" r="10"/><path d="m7.5 12.5 3 3 6-6.5"/></svg>',
    lock: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><rect x="5" y="11" width="14" height="10" rx="2"/><path d="M8 11V7a4 4 0 0 1 8 0v4"/></svg>',
    dl: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M12 3v12m0 0-5-5m5 5 5-5M4 21h16"/></svg>'
  };

  function post(path, body) {
    return fetch(PROXY + '/' + path, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().catch(function () { return { ok: false, code: 'generic' }; });
    }, function () { return { ok: false, code: 'generic' }; });
  }

  /* ---------------- shared state ---------------- */
  var S = {
    step: 'phone',          // phone | otp | done
    phone: read('tco_phone') || '',
    msg: '', msgType: '',
    busy: false,
    resendAt: 0,
    token: null,
    verifiedPhone: null,
    session: null,
    cartLoaded: false
  };

  // Fail-open safety: if the OTP service is not reachable (App Proxy not set up / outage),
  // never block customers from ordering. S.off is set by probe() below.
  function verified() { return S.off || (S.step === 'done' && tokenValid(S.token)); }
  function setMsg(text, type) { S.msg = text; S.msgType = type || ''; }

  /* ---------------- widget markup ---------------- */
  var WA_ICON = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12.04 2a9.9 9.9 0 0 0-8.4 15.1L2 22l5.05-1.6A9.94 9.94 0 1 0 12.04 2Zm0 18.1a8.1 8.1 0 0 1-4.13-1.13l-.3-.18-3 .95.98-2.9-.2-.31a8.1 8.1 0 1 1 6.65 3.57Zm4.44-6.07c-.24-.12-1.44-.71-1.66-.79-.22-.08-.39-.12-.55.12-.16.24-.63.79-.77.95-.14.16-.28.18-.52.06-.24-.12-1.02-.38-1.94-1.2-.72-.64-1.2-1.43-1.34-1.67-.14-.24-.02-.37.1-.49.11-.11.24-.28.36-.42.12-.14.16-.24.24-.4.08-.16.04-.3-.02-.42-.06-.12-.55-1.32-.75-1.8-.2-.47-.4-.41-.55-.42h-.47c-.16 0-.42.06-.64.3-.22.24-.84.82-.84 2s.86 2.32.98 2.48c.12.16 1.7 2.6 4.1 3.65.57.25 1.02.4 1.37.5.58.18 1.1.16 1.51.1.46-.07 1.44-.59 1.64-1.16.2-.57.2-1.06.14-1.16-.06-.1-.22-.16-.46-.28Z"/></svg>';
  function widgetHTML(kind) {
    var done = S.step === 'done';
    var title = done ? 'Mobile number verified' : ({ download: 'Verify to download', builder: 'Verify to get your estimate', login: 'Log in to TechCure', staff: 'Staff verification' }[kind] || 'Verify to place your order');
    var hint = kind === 'login' ? 'Enter your mobile number. We’ll send a 6-digit code on WhatsApp — no password needed. Your orders, estimates and addresses stay in one place.'
      : kind === 'staff' ? 'Enter your registered staff mobile number. We’ll send a 6-digit code on WhatsApp.'
      : kind === 'builder' ? 'Enter your mobile number. We’ll send a 6-digit code on WhatsApp — your build stays saved.'
      : kind === 'download' ? 'Enter your mobile number. We’ll send a 6-digit code on WhatsApp to unlock the download.'
      : 'Enter your mobile number. We’ll send a 6-digit code on WhatsApp before you place the order.';
    var body = '';
    if (done) {
      body = '<div class="tco__done" role="status">' + ICON.ok + '<span>' + esc(pretty(S.verifiedPhone)) + ' is verified</span>' +
        '<button type="button" class="tco__link" data-tco="change">Change</button></div>';
    } else {
      var phoneId = 'tco-phone-' + kind, otpId = 'tco-otp-' + kind;
      body =
        '<ol class="tco__steps" aria-hidden="true"><li class="' + (S.step === 'phone' ? 'is-on' : 'is-done') + '"><b>1</b>Mobile number</li><li class="' + (S.step === 'otp' ? 'is-on' : '') + '"><b>2</b>WhatsApp code</li></ol>' +
        '<label class="tco__label" for="' + phoneId + '">Mobile number</label>' +
        '<div class="tco__field"><span class="tco__cc" aria-hidden="true">🇮🇳 +91</span>' +
        '<input class="tco__input" id="' + phoneId + '" data-tco="phone" type="tel" inputmode="numeric" autocomplete="tel-national" maxlength="10" placeholder="98765 43210" value="' + esc(S.phone) + '"' + (S.step === 'otp' ? ' readonly' : '') + ' aria-describedby="tco-msg-' + kind + '"></div>' +
        (S.step === 'phone' ? '<button type="button" class="tco__btn tco__btn--block" data-tco="send"' + (S.busy ? ' disabled' : '') + '>' + (S.busy ? '<span class="tc-spin" aria-hidden="true"></span>Sending…' : WA_ICON + ' Send code on WhatsApp') + '</button>' : '');
      if (S.step === 'otp') {
        body +=
          '<label class="tco__label" for="' + otpId + '" style="margin-top:14px">Enter the 6-digit code</label>' +
          '<div class="tco__field tco__field--otp"><input class="tco__input tco__input--otp" id="' + otpId + '" data-tco="otp" type="text" inputmode="numeric" autocomplete="one-time-code" maxlength="6" placeholder="······" aria-describedby="tco-msg-' + kind + '"></div>' +
          '<button type="button" class="tco__btn tco__btn--green tco__btn--block" data-tco="verify"' + (S.busy ? ' disabled' : '') + '>' + (S.busy ? '<span class="tc-spin" aria-hidden="true"></span>Checking…' : 'Verify & continue') + '</button>' +
          '<div class="tco__meta"><button type="button" class="tco__link" data-tco="change">Change number</button>' +
          '<button type="button" class="tco__link" data-tco="resend" data-tco-timer disabled></button></div>';
      }
    }
    return '<div class="tco__head"><span class="tco__icon' + (done ? ' tco__icon--ok' : '') + '">' + (done ? ICON.ok : ICON.phone) + '</span><div><h3 class="tco__title">' + title + '</h3>' +
      (done ? '' : '<p class="tco__hint">' + hint + '</p>') + '</div></div>' + body +
      '<p class="tco__msg' + (S.msgType ? ' tco__msg--' + S.msgType : '') + '" id="tco-msg-' + kind + '" role="' + (S.msgType === 'err' ? 'alert' : 'status') + '" aria-live="polite">' + esc(S.msg) + '</p>' +
      '<p class="tco__help">Need help? <a href="https://wa.me/' + WA_NUM + '" target="_blank" rel="noopener">WhatsApp ' + WA_TXT + '</a></p>';
  }

  function widgets() { return document.querySelectorAll('.tco[data-tco-kind]'); }

  function renderAll() {
    var active = document.activeElement, role = active && active.getAttribute && active.getAttribute('data-tco');
    var activeKind = active && active.closest && active.closest('.tco') ? active.closest('.tco').getAttribute('data-tco-kind') : null;
    widgets().forEach(function (w) { w.innerHTML = widgetHTML(w.getAttribute('data-tco-kind')); });
    updateTimer();
    if (activeKind && role) {
      var again = document.querySelector('.tco[data-tco-kind="' + activeKind + '"] [data-tco="' + role + '"]');
      if (again && again.focus) again.focus();
    }
    applyLocks();
  }

  function updateTimer() {
    var left = Math.max(0, Math.ceil((S.resendAt - Date.now()) / 1000));
    document.querySelectorAll('[data-tco-timer]').forEach(function (b) {
      b.disabled = left > 0 || S.busy;
      b.textContent = left > 0 ? 'Resend code in ' + Math.floor(left / 60) + ':' + String(left % 60).padStart(2, '0') : 'Resend code';
    });
  }
  setInterval(function () {
    updateTimer();
    if (S.step === 'done' && !tokenValid(S.token)) { // 30-minute token ran out
      S.step = 'phone'; S.token = null; setMsg(t('not_verified'), 'err'); renderAll();
    }
  }, 1000);

  /* ---------------- actions ---------------- */
  function kindOf(el) { var w = el.closest('.tco'); return w ? w.getAttribute('data-tco-kind') : 'checkout'; }

  function doSend(kind) {
    var input = document.querySelector('.tco[data-tco-kind="' + kind + '"] [data-tco="phone"]');
    var ten = norm10(input ? input.value : S.phone);
    if (!ten) { setMsg(t('invalid_phone'), 'err'); renderAll(); return; }
    S.phone = ten; store('tco_phone', ten); S.busy = true; setMsg('', ''); renderAll();
    post('send', { phone: ten }).then(function (r) {
      S.busy = false;
      if (r.ok) {
        S.step = 'otp'; S.resendAt = Date.now() + (r.resendIn || 60) * 1000;
        setMsg(t('sent', { p: pretty(ten) }), 'ok'); renderAll();
        var otp = document.querySelector('.tco[data-tco-kind="' + kind + '"] [data-tco="otp"]'); if (otp) otp.focus();
        return;
      }
      if (r.code === 'cooldown') { S.step = 'otp'; S.resendAt = Date.now() + (r.retryAfter || 60) * 1000; } // a code was already sent
      setMsg(t(r.code, { s: r.retryAfter || 60, m: Math.ceil((r.retryAfter || 900) / 60) }), 'err');
      renderAll();
    });
  }

  function doVerify(kind) {
    var input = document.querySelector('.tco[data-tco-kind="' + kind + '"] [data-tco="otp"]');
    var code = digits(input && input.value);
    if (code.length !== 6) { setMsg(t('invalid_otp_format'), 'err'); renderAll(); return; }
    S.busy = true; setMsg('', ''); renderAll();
    post('verify', { phone: S.phone, otp: code, purpose: kind === 'checkout' ? 'checkout' : kind === 'login' ? 'login' : kind === 'staff' ? 'staff' : 'download' }).then(function (r) {
      if (!r.ok) {
        S.busy = false;
        if (r.code === 'too_many_attempts' || r.code === 'expired' || r.code === 'no_otp') { S.step = 'phone'; S.resendAt = 0; }
        setMsg(t(r.code, { n: r.attemptsLeft }), 'err'); renderAll();
        return;
      }
      S.token = r.token; S.verifiedPhone = r.phone; S.session = r.session || null; store('tco_token', r.token);
      saveCartAttributes().then(function (saved) {
        S.busy = false; S.step = 'done';
        setMsg(saved ? '' : t('cart_save'), saved ? '' : 'err');
        renderAll();
        document.dispatchEvent(new CustomEvent('tco:verified', { detail: { phone: r.phone, kind: kind, token: S.token, session: S.session } }));
      });
    });
  }

  function saveCartAttributes() {
    return fetch('/cart/update.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { 'Verified Phone': S.verifiedPhone, 'OTP Verified': 'Yes', '_otp_token': S.token } })
    }).then(function (r) { return r.ok; }, function () { return false; });
  }

  function clearCartAttributes() {
    return fetch('/cart/update.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { 'Verified Phone': '', 'OTP Verified': '', '_otp_token': '' } })
    }).catch(function () {});
  }

  function doChange() {
    var wasDone = S.step === 'done';
    S.step = 'phone'; S.token = null; S.verifiedPhone = null; S.resendAt = 0; setMsg('', '');
    store('tco_token', null);
    if (wasDone) clearCartAttributes();
    renderAll();
    var p = document.querySelector('.tco [data-tco="phone"]'); if (p) { p.focus(); p.select && p.select(); }
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.tco [data-tco]');
    if (!b) return;
    var act = b.getAttribute('data-tco'), kind = kindOf(b);
    if (act === 'send' || act === 'resend') { e.preventDefault(); if (!b.disabled) doSend(kind); }
    else if (act === 'verify') { e.preventDefault(); doVerify(kind); }
    else if (act === 'change') { e.preventDefault(); doChange(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' || !e.target.closest) return;
    var f = e.target.closest('.tco [data-tco="phone"], .tco [data-tco="otp"]');
    if (!f) return;
    e.preventDefault(); e.stopPropagation(); // never submit the surrounding cart form
    if (f.getAttribute('data-tco') === 'phone' && S.step === 'phone') doSend(kindOf(f));
    if (f.getAttribute('data-tco') === 'otp') doVerify(kindOf(f));
  }, true);
  document.addEventListener('input', function (e) {
    var f = e.target.closest && e.target.closest('.tco [data-tco="phone"], .tco [data-tco="otp"]');
    if (!f) return;
    var clean = digits(f.value).slice(0, f.getAttribute('data-tco') === 'otp' ? 6 : 10);
    if (f.value !== clean) f.value = clean;
    if (f.getAttribute('data-tco') === 'phone') S.phone = clean;
    if (f.getAttribute('data-tco') === 'otp' && clean.length === 6 && !S.busy) doVerify(kindOf(f)); // auto-submit full code
  });

  /* ---------------- 1) checkout gate ---------------- */
  function applyLocks() {
    var ok = verified();
    html.classList.toggle('tco-unverified', !ok);
    document.querySelectorAll(CHECKOUT_SEL).forEach(function (btn) {
      if (!ok) {
        if (!btn.hasAttribute('data-tco-locked')) { btn.setAttribute('data-tco-locked', btn.disabled ? 'was-disabled' : '1'); }
        btn.disabled = true; btn.setAttribute('aria-disabled', 'true'); btn.classList.add('tco-locked-btn');
        btn.title = 'Verify your mobile number first';
      } else if (btn.hasAttribute('data-tco-locked')) {
        if (btn.getAttribute('data-tco-locked') !== 'was-disabled') btn.disabled = false;
        btn.removeAttribute('data-tco-locked'); btn.removeAttribute('aria-disabled'); btn.classList.remove('tco-locked-btn'); btn.removeAttribute('title');
      }
    });
  }

  function mountGates() {
    if (S.off) { applyLocks(); return; }
    document.querySelectorAll(CHECKOUT_SEL).forEach(function (btn) {
      var anchor = btn.closest('.cart__ctas') || btn;
      var prev = anchor.previousElementSibling;
      if (prev && prev.classList.contains('tco') && prev.getAttribute('data-tco-kind') === 'checkout') return;
      var w = document.createElement('div');
      w.className = 'tco'; w.setAttribute('data-tco-kind', 'checkout'); w.setAttribute('data-skip-node-update', '');
      w.innerHTML = widgetHTML('checkout');
      anchor.parentNode.insertBefore(w, anchor);
    });
    // cart drawer and cart page share one id — keep only the first widget per container
    applyLocks(); updateTimer();
  }

  // Block every route to checkout while unverified (theme JS, keyboard, re-rendered buttons)
  document.addEventListener('click', function (e) {
    if (verified() || !e.target.closest) return;
    var c = e.target.closest(CHECKOUT_SEL + ', a[href$="/checkout"], a[href*="/checkout?"]');
    if (!c) return;
    e.preventDefault(); e.stopImmediatePropagation();
    nudge();
  }, true);
  document.addEventListener('submit', function (e) {
    if (verified()) return;
    var sub = e.submitter;
    if (sub && sub.name === 'checkout') { e.preventDefault(); e.stopImmediatePropagation(); nudge(); }
  }, true);

  function nudge() {
    setMsg('Please verify your mobile number to continue.', 'err');
    renderAll();
    var w = document.querySelector('.tco[data-tco-kind="checkout"]');
    if (w) { w.scrollIntoView({ block: 'center', behavior: 'smooth' }); var i = w.querySelector('[data-tco="phone"]:not([readonly]), [data-tco="otp"]'); if (i) i.focus({ preventScroll: true }); }
  }

  function loadCart() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var a = cart.attributes || {};
        var tok = a._otp_token || read('tco_token');
        if (a['OTP Verified'] === 'Yes' && a['Verified Phone'] && tokenValid(a._otp_token)) {
          S.step = 'done'; S.token = a._otp_token; S.verifiedPhone = a['Verified Phone'];
        } else if (tokenValid(tok) && S.step !== 'done') {
          // verified earlier (e.g. on the download page) — carry it into the cart
          try { var p = JSON.parse(atob(tok.split('.')[0].replace(/-/g, '+').replace(/_/g, '/'))).phone; S.token = tok; S.verifiedPhone = p; S.step = 'done'; saveCartAttributes(); } catch (e) {}
        }
        S.cartLoaded = true;
        renderAll();
      }).catch(function () { applyLocks(); });
  }

  /* ---------------- 2) download lock ---------------- */
  function mountDownloads() {
    document.querySelectorAll('[data-tco-download]').forEach(function (sec) {
      var slot = sec.querySelector('[data-tco-slot]');
      if (slot && !slot.querySelector('.tco')) {
        var w = document.createElement('div');
        w.className = 'tco'; w.setAttribute('data-tco-kind', 'download');
        w.innerHTML = widgetHTML('download');
        slot.appendChild(w);
      }
      sec.querySelectorAll('[data-tco-file]').forEach(function (btn) {
        var open = verified(), state = open ? 'open' : 'locked';
        if (btn.getAttribute('data-tco-state') === state) return; // avoid re-render loops
        btn.setAttribute('data-tco-state', state);
        btn.classList.toggle('tco-file__btn--open', open);
        btn.setAttribute('aria-disabled', open ? 'false' : 'true');
        btn.innerHTML = (open ? ICON.dl + ' Download' : ICON.lock + ' Locked');
      });
    });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-tco-file]');
    if (!btn) return;
    e.preventDefault();
    if (!verified()) {
      var i = document.querySelector('.tco[data-tco-kind="download"] [data-tco="phone"]');
      setMsg('Verify your mobile number to unlock the download.', 'err'); renderAll();
      if (i) i.focus();
      return;
    }
    btn.setAttribute('aria-busy', 'true');
    post('download', { token: S.token, file: btn.getAttribute('data-tco-file') }).then(function (r) {
      btn.removeAttribute('aria-busy');
      if (r.ok && r.url) {
        var a = document.createElement('a');
        a.className = 'tco__dl'; a.href = r.url; a.rel = 'noopener'; a.setAttribute('download', '');
        a.innerHTML = ICON.dl + ' ' + esc(r.label || 'Download') + ' — click if it didn’t start';
        var li = btn.closest('.tco-file');
        if (li && !(li.nextElementSibling && li.nextElementSibling.classList.contains('tco-dlrow'))) {
          var row = document.createElement('li'); row.className = 'tco-dlrow'; row.appendChild(a);
          li.insertAdjacentElement('afterend', row);
        }
        window.location.href = r.url;
      } else {
        if (r.code === 'not_verified') { S.step = 'phone'; S.token = null; }
        setMsg(t(r.code), 'err'); renderAll();
      }
    });
  });


  /* ---------------- 3) PC Builder: OTP before estimate PDF / WhatsApp / Share (customers only) ---------------- */
  var PCB_SEL = '#pcb-pdf, #pcb-wa, #pcb-share, #pcb-ppdf, #pcb-pwa';
  var pcbPending = null;
  function pcbStaff() {
    try { var st = JSON.parse(localStorage.getItem('tc_staff_tok') || 'null'); return !!(st && /^[0-9a-f]{64}$/.test(st.sig || '')); } catch (e) { return false; }
  }
  function pcbVerified() {
    try { var v = JSON.parse(localStorage.getItem('tc_vp') || 'null'); return !!(v && v.exp > Date.now() && norm10(v.p)); } catch (e) { return false; }
  }
  function pcbMarkVerified() {
    try { localStorage.setItem('tc_vp', JSON.stringify({ p: digits(S.verifiedPhone).slice(-10), exp: tokenExp(S.token) || Date.now() + 1800000, src: 'sms' })); } catch (e) {}
  }
  function pcbClose() { var m = document.getElementById('tco-modal'); if (m) m.remove(); pcbPending = null; }
  function pcbOpen(btn) {
    pcbPending = btn;
    if (S.step === 'done' && tokenValid(S.token)) { pcbMarkVerified(); var b0 = btn; pcbPending = null; var ph0 = document.getElementById('pcb-phone'); if (ph0) ph0.value = digits(S.verifiedPhone).slice(-10); window.__tcPass = true; b0.click(); return; }
    var old = document.getElementById('tco-modal'); if (old) old.remove();
    var m = document.createElement('div');
    m.id = 'tco-modal'; m.className = 'tco-modal'; m.setAttribute('role', 'dialog'); m.setAttribute('aria-modal', 'true'); m.setAttribute('aria-label', 'Verify your mobile number');
    m.innerHTML = '<div class="tco-modal__box"><button type="button" class="tco-modal__x" aria-label="Close">×</button><div class="tco" data-tco-kind="builder"></div></div>';
    document.body.appendChild(m);
    m.querySelector('.tco').innerHTML = widgetHTML('builder');
    updateTimer();
    m.addEventListener('click', function (ev) { if (ev.target === m || ev.target.closest('.tco-modal__x')) pcbClose(); });
    var f = m.querySelector('[data-tco="phone"], [data-tco="otp"]'); if (f) f.focus();
  }
  /* Generic modal for customer login and staff verification (Oct 2026) */
  var staffCb = null;
  function openModal(kind) {
    S.step = 'phone'; S.token = null; S.verifiedPhone = null; S.session = null; S.resendAt = 0; setMsg('', ''); pcbPending = null;
    var old = document.getElementById('tco-modal'); if (old) old.remove();
    var m = document.createElement('div');
    m.id = 'tco-modal'; m.className = 'tco-modal'; m.setAttribute('role', 'dialog'); m.setAttribute('aria-modal', 'true'); m.setAttribute('aria-label', kind === 'staff' ? 'Staff verification' : 'Log in');
    m.innerHTML = '<div class="tco-modal__box"><button type="button" class="tco-modal__x" aria-label="Close">×</button><div class="tco" data-tco-kind="' + kind + '"></div></div>';
    document.body.appendChild(m);
    m.querySelector('.tco').innerHTML = widgetHTML(kind);
    updateTimer();
    m.addEventListener('click', function (ev) { if (ev.target === m || ev.target.closest('.tco-modal__x')) pcbClose(); });
    var f = m.querySelector('[data-tco="phone"]'); if (f) f.focus();
  }
  window.TCOTP_API = { login: function () { openModal('login'); }, staff: function (cb) { staffCb = cb; openModal('staff'); } };
  document.addEventListener('tco:verified', function (e) {
    var d = e.detail || {};
    if (d.kind === 'login' || d.kind === 'staff') {
      setTimeout(function () { pcbClose(); if (d.kind === 'staff' && staffCb) { var cb = staffCb; staffCb = null; cb(d.token, d.phone); } }, 700);
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && document.getElementById('tco-modal')) pcbClose(); });
  /* Tab / Shift+Tab stay inside the open popup */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var m = document.getElementById('tco-modal'); if (!m) return;
    var f = [].slice.call(m.querySelectorAll('button:not([disabled]), input:not([disabled]):not([readonly]), a[href]')).filter(function (x) { return x.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1], cur = document.activeElement;
    if (!m.contains(cur)) { e.preventDefault(); first.focus(); }
    else if (e.shiftKey && cur === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && cur === last) { e.preventDefault(); first.focus(); }
  });
  /* phones: when the keyboard opens, shrink the sheet to the visible area and scroll the field into view */
  if (window.visualViewport) {
    var vv = window.visualViewport, setVv = function () { html.style.setProperty('--tco-vvh', Math.round(vv.height) + 'px'); };
    vv.addEventListener('resize', setVv); vv.addEventListener('scroll', setVv); setVv();
  }
  document.addEventListener('focusin', function (e) {
    var t = e.target; if (!t || !t.closest || !t.closest('#tco-modal')) return;
    if (t.matches && t.matches('input')) setTimeout(function () { try { t.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (er) {} }, 350);
  });
  // window-capture runs before the builder's own document-capture listener
  window.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest(PCB_SEL);
    if (!b || S.off || window.__tcPass || pcbStaff() || pcbVerified()) return;
    e.preventDefault(); e.stopImmediatePropagation();
    // delivery / pickup must be chosen first (ask before the WhatsApp code)
    if (window.__tcNeedDlv && b.matches && b.matches('#pcb-pdf, #pcb-wa') && !window.__tcNeedDlv()) return;
    pcbOpen(b);
  }, true);
  document.addEventListener('tco:verified', function () {
    pcbMarkVerified();
    if (pcbPending) {
      var b = pcbPending;
      setTimeout(function () {
        pcbClose();
        // The verified number is the final identity: fill the builder's mobile field and skip its old name + mobile sheet
        var ph = document.getElementById('pcb-phone'); if (ph) ph.value = digits(S.verifiedPhone).slice(-10);
        window.__tcPass = true; b.click();
      }, 700);
    }
  });

  /* ---------------- boot ---------------- */
  var _renderAllBase = renderAll;
  renderAll = function () { _renderAllBase(); mountDownloads(); };

  var pending = false;
  function refresh() {
    if (pending) return; pending = true;
    requestAnimationFrame(function () { pending = false; mountGates(); mountDownloads(); });
  }
  function probe() {
    // GET /apps/otp/ping answers 200 when the OTP service is up (no SMS, no console error). If it is down, never block customers from ordering.
    return fetch(PROXY + '/ping', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok; }, function () { return false; })
      .then(function (up) {
        if (!up) { S.off = true; widgets().forEach(function (w) { if (w.getAttribute('data-tco-kind') === 'checkout') w.remove(); }); applyLocks(); html.classList.remove('tco-unverified'); console.warn('[tc-otp] OTP service unavailable – checkout left open'); }
      });
  }
  function boot() {
    var tok = read('tco_token');
    if (tokenValid(tok)) {
      try { S.verifiedPhone = JSON.parse(atob(tok.split('.')[0].replace(/-/g, '+').replace(/_/g, '/'))).phone; S.token = tok; S.step = 'done'; } catch (e) {}
    }
    mountGates(); mountDownloads();
    if (document.querySelector(CHECKOUT_SEL)) loadCart();
    if (document.querySelector(CHECKOUT_SEL + ', ' + PCB_SEL)) probe();
    // cart drawer / cart page are re-rendered by the theme: re-mount and re-lock every time
    new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) {
        var t0 = list[i].target;
        if (t0 && t0.closest && t0.closest('.tco')) continue; // our own re-render
        refresh(); break;
      }
    }).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('cart:update', function () { refresh(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
